export default __webpack_public_path__ + "media/54e754f2e229706b7cceef55ee6a8cb58c65a923b5a0ba84001d247264f2a8d7.svg";